import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody
} from '@heroui/react';
import { 
  Calendar,
  Download,
  ExternalLink
} from 'lucide-react';

const CalendarLinks = ({ calendarLinks }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!calendarLinks) {
    return null;
  }

  const handleCalendarClick = (url, type) => {
    if (!url) {
      console.error('No URL provided for calendar type:', type);
      alert('Link do calendário não disponível');
      return;
    }

    if (type === 'ics') {
      // For ICS files, create a download link
      downloadICS(url);
    } else {
      // For web calendars, open in new window
      try {
        window.open(url, '_blank', 'noopener,noreferrer');
      } catch (error) {
        console.error('Error opening calendar link:', error);
        alert('Erro ao abrir link do calendário');
      }
    }
    setIsOpen(false);
  };

  const downloadICS = (icsData) => {
    try {
      const blob = new Blob([icsData], { type: 'text/calendar;charset=utf-8' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'evento.ics';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error downloading ICS file:', error);
      alert('Erro ao baixar arquivo de calendário');
    }
  };

  const calendarOptions = [
    {
      key: 'google',
      label: 'Google Calendar',
      icon: '📅',
      url: calendarLinks.google,
      type: 'google'
    },
    {
      key: 'outlook',
      label: 'Outlook',
      icon: '📧',
      url: calendarLinks.outlook,
      type: 'outlook'
    },
    {
      key: 'yahoo',
      label: 'Yahoo Calendar',
      icon: '🟣',
      url: calendarLinks.yahoo,
      type: 'yahoo'
    },
    {
      key: 'ics',
      label: 'Baixar arquivo ICS',
      icon: '💾',
      url: calendarLinks.ics,
      type: 'ics'
    }
  ];

  return (
    <Card className="bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200 mt-3 hover:shadow-md transition-shadow">
      <CardBody className="p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="p-1 bg-blue-100 rounded-full">
              <Calendar className="w-4 h-4 text-blue-600" />
            </div>
            <div>
              <span className="text-sm font-medium text-blue-800">
                Adicionar ao Calendário
              </span>
              <div className="text-xs text-blue-600">
                📌 Salve este evento no seu calendário
              </div>
            </div>
          </div>
          
          <Dropdown 
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            placement="bottom-end"
            classNames={{
              base: "before:bg-default-200",
              content: "bg-white shadow-2xl border border-gray-200 rounded-lg p-0"
            }}
          >
            <DropdownTrigger>
              <Button
                size="sm"
                color="primary"
                variant="solid"
                startContent={<Calendar className="w-4 h-4" />}
                className="min-w-0 shadow-md hover:shadow-lg transition-shadow"
              >
                Adicionar
              </Button>
            </DropdownTrigger>
            
            <DropdownMenu
              aria-label="Opções de calendário"
              className="w-56"
              itemClasses={{
                base: "gap-2 data-[hover=true]:bg-blue-50"
              }}
              classNames={{
                base: "bg-white",
                list: "bg-white"
              }}
            >
              {calendarOptions.map((option) => (
                <DropdownItem
                  key={option.key}
                  startContent={
                    <span className="text-lg">{option.icon}</span>
                  }
                  endContent={
                    option.type === 'ics' ? (
                      <Download className="w-4 h-4 text-gray-400" />
                    ) : (
                      <ExternalLink className="w-4 h-4 text-gray-400" />
                    )
                  }
                  onPress={() => handleCalendarClick(option.url, option.type)}
                  className="text-sm"
                  description={
                    option.type === 'ics' 
                      ? 'Baixar arquivo para importar'
                      : 'Abrir no navegador'
                  }
                >
                  {option.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </CardBody>
    </Card>
  );
};

export default CalendarLinks;
